import { useMatch, useNavigate, useSearchParams } from "react-router-dom";
import People from "../../svg/People";
import Calendar from "../../svg/Calendar";
import IDCard from "../../svg/IDCard";

const AttendeeBottomBar = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const matchedEventId = useMatch("/attendee/:eventId/*");
  const eventId = matchedEventId?.params?.eventId;
  return (
    <div className="fixed bottom-0 h-[65px] z-20 w-full items-center flex shadow md:hidden bg-white justify-between px-7">
      <span
        className={`${
          searchParams.get("tab") === "about"
            ? "text-primary"
            : "text-[#C5C5C7]"
        } flex flex-col justify-center items-center cursor-pointer`}
        onClick={() => navigate(`/attendee/${eventId}?tab=about`)}
      >
        <svg
          width="24px"
          height="24px"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
        >
          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
          <g
            id="SVGRepo_tracerCarrier"
            stroke-linecap="round"
            stroke-linejoin="round"
          ></g>
          <g id="SVGRepo_iconCarrier">
            <path
              fill={searchParams.get("tab") === "about" ? "#A55EEA" : "#C5C5C7"}
              fill-rule="evenodd"
              d="M11.2 1.65a2 2 0 00-2.4 0L1.885 6.836a2.017 2.017 0 00-.783 1.907c.145.99.398 2.92.398 4.257 0 1.11-.175 2.638-.32 3.702C1.019 17.899 1.94 19 3.178 19h13.646c1.236 0 2.16-1.1 1.997-2.298-.145-1.064-.32-2.592-.32-3.702 0-1.337.253-3.268.398-4.257a2.017 2.017 0 00-.783-1.907L11.2 1.65zM3.085 8.436L10 3.25l6.915 5.186.001.001.002.003a.025.025 0 010 .013C16.776 9.435 16.5 11.5 16.5 13c0 1.258.193 2.903.338 3.97v.013a.035.035 0 01-.014.017H14v-5a4 4 0 00-8 0v5H3.176c-.001 0-.004-.002-.006-.005a.035.035 0 01-.007-.012.026.026 0 010-.012c.144-1.068.337-2.713.337-3.971 0-1.5-.275-3.565-.419-4.547l.001-.013.003-.004zM8 17h4v-5a2 2 0 10-4 0v5z"
            ></path>{" "}
          </g>
        </svg>

        <span className="text-[12px] font-[600]">Home</span>
      </span>

      <span
        className={`${
          searchParams.get("tab") === "agenda"
            ? "text-primary"
            : "text-[#C5C5C7]"
        } flex flex-col justify-center items-center cursor-pointer`}
        onClick={() => navigate(`/attendee/${eventId}?tab=agenda`)}
      >
        <div className="h-[23px] w-[23px]">
          <Calendar
            color={searchParams.get("tab") === "agenda" ? "#A55EEA" : ""}
          />
        </div>
        <span className="text-[12px] font-[600]">Agenda</span>
      </span>
      <span
        className={`${
          searchParams.get("tab") === "leads"
            ? "text-primary"
            : "text-[#C5C5C7]"
        } flex flex-col justify-center items-center  cursor-pointer`}
        onClick={() => navigate(`/attendee/${eventId}?tab=leads`)}
      >
        <div className="h-[23px] w-[23px]">
          <People
            color={searchParams.get("tab") === "leads" ? "#A55EEA" : ""}
          />
        </div>

        <span className="text-[12px] font-[600]">Leads</span>
      </span>
      <div
        className="inline-flex gap-1.5 justify-center items-center  cursor-pointer bg-primary rounded-[20px] text-white text-[14px] font-[600] px-4 py-[8px]"
        onClick={() => {
          navigate(`/connections/scan?camera=environment&eventId=${eventId}`);
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="23"
          fill="#fff"
          viewBox="0 -960 960 960"
          width="23"
        >
          <path d="M109.825-707Q97-707 88.5-715.625T80-737v-113q0-12.75 8.625-21.375T110-880h113q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5 0 12.825-8.625 21.325T223-820h-83v83q0 12.75-8.675 21.375-8.676 8.625-21.5 8.625ZM110-80q-12.75 0-21.375-8.625T80-110v-113q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T140-223v83h83q12.75 0 21.375 8.675 8.625 8.676 8.625 21.5Q253-97 244.375-88.5T223-80H110Zm627 0q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T737-140h83v-83q0-12.75 8.675-21.375 8.676-8.625 21.5-8.625 12.825 0 21.325 8.625T880-223v113q0 12.75-8.625 21.375T850-80H737Zm112.825-627Q837-707 828.5-715.625T820-737v-83h-83q-12.75 0-21.375-8.675-8.625-8.676-8.625-21.5 0-12.825 8.625-21.325T737-880h113q12.75 0 21.375 8.625T880-850v113q0 12.75-8.675 21.375-8.676 8.625-21.5 8.625ZM708-251h63v63h-63v-63Zm0-126h63v63h-63v-63Zm-63 63h63v63h-63v-63Zm-63 63h63v63h-63v-63Zm-63-63h63v63h-63v-63Zm126-126h63v63h-63v-63Zm-63 63h63v63h-63v-63Zm-63-63h63v63h-63v-63Zm252-332v252H519v-252h252ZM440-440v252H188v-252h252Zm0-332v252H188v-252h252Zm-50 534v-152H238v152h152Zm0-332v-152H238v152h152Zm331 0v-152H569v152h152Z" />
        </svg>
        Scan
      </div>

      {/* <span
        className={`${
          searchParams.get("tab") === "cards"
            ? "text-primary"
            : "text-[#C5C5C7]"
        } flex flex-col justify-center items-center cursor-pointer`}
        onClick={() => navigate(`/attendee/${eventId}?tab=cards`)}
      >
        <div className="h-[23px] w-[23px]">
          <IDCard
            color={searchParams.get("tab") === "cards" ? "#A55EEA" : ""}
          />
        </div>
        <span className="text-[12px] font-[600]">Cards</span>
      </span> */}

      {/* <span
        className={`${
          searchParams.get("tab") === "speakers"
            ? "text-primary"
            : "text-[#C5C5C7]"
        } flex flex-col justify-center items-center  cursor-pointer`}
        onClick={() => navigate(`/attendee/${eventId}?tab=speakers`)}
      >
        <div className="h-[22px] w-[22px]">
          <Speakers
            color={searchParams.get("tab") === "speakers" ? "#A55EEA" : ""}
          />
        </div>

        <span className="text-[11px] font-[600]">Speakers</span>
      </span> */}
    </div>
  );
};

export default AttendeeBottomBar;
